import { backendUrl, chainData, ChainID, noExistCoinGeckoTokens } from '@jdiyield/constants'
import { PriceList, Token } from '@jdiyield/interfaces'
import { api } from '@jdiyield/utils'

import { findToken } from './utils'

// const chunk = (arr, n) => (arr.length ? [arr.slice(0, n), ...chunk(arr.slice(n), n)] : [])

// Create `axios-cache-adapter` instance

const getPrices = async (tokens: Token[]): Promise<PriceList> => {
  // const priceData = await api.get(`${mainUrl}/api/price/get`)
  const res = await api.get(`${backendUrl}/prices`)
  const idsNotUpdateOnBE = tokens.filter(({ tokenId }) => !res.data[tokenId] && !!tokenId).map(({ tokenId }) => tokenId)
  const dataNotUpdateOnBE =
    idsNotUpdateOnBE.length === 0
      ? []
      : (
          await api.get(`https://api.coingecko.com/api/v3/simple/price`, {
            params: {
              ids: idsNotUpdateOnBE.join(','),
              vs_currencies: 'usd'
            }
          })
        ).data
  const prices = {}
  for (const [key, v] of Object.entries({ ...res.data, ...dataNotUpdateOnBE }) as any) {
    if (v) {
      if (v.usd) {
        prices[key] = v
      } else {
        prices[key] = { usd: v }
      }
    }
  }
  const result = {} as PriceList

  tokens.forEach(({ id, tokenId, address }) => {
    const newId = tokenId || id
    result[address] = prices?.[newId] ?? { usd: 0 }
  })
  const allResultAddresses = Object.keys(result)
  const allDexguruAddress = Object.values(noExistCoinGeckoTokens)

  const missingDexgurucoins = allDexguruAddress.filter((o) => !allResultAddresses.includes(o))
  const dexGuruAddresses = missingDexgurucoins.map((token) => token.toLowerCase())

  const dexGuruPrices = await Promise.all(
    dexGuruAddresses.map((token) => {
      try {
        const chainID = Object.values(chainData).find(({ chainName }) => findToken(tokens, token)?.chain === chainName)
          .chainID as ChainID
        return getPrice(token, chainID)
      } catch (error) {
        console.log(findToken(tokens, token), error)
        return 0
      }
    })
  )
  dexGuruAddresses.forEach((token, i) => (result[token] = { usd: dexGuruPrices[i] }))

  return result
}

async function getPrice(tokenAddress: string, chainID: ChainID): Promise<number> {
  try {
    const result = await api.get(`https://api.dex.guru/v1/tokens/${tokenAddress}-${chainData[chainID].dexguruID}`)
    const { priceUSD } = result?.data
    return priceUSD
  } catch (e) {
    return 0
  }
}

export { getPrice, getPrices }
